import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle';
import { forwardRef, type PropsWithChildren } from 'react';

const CustomHeader = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DialogTitleProps>
>(({ children, ...props }, ref) => {
  return (
    <DialogTitle ref={ref} {...props}>
      {children}
    </DialogTitle>
  );
});

CustomHeader.displayName = 'CustomHeader';

export default CustomHeader;
